"use client";

import { useTranslations } from "next-intl";
import { Alert } from "@leabankab/component-library";
import { useCurrency } from "@/hooks";

interface MandatoryDebtsBannerProps {
	/** Amount the offer requires the customer to redeem. */
	mandatory: number;
	/** Whether the credit check supplied debts to start from. */
	hasSuggestions: boolean;
}

/** Names the amount that has to be redeemed before the step can be submitted. */
export const MandatoryDebtsBanner = ({
	mandatory,
	hasSuggestions,
}: MandatoryDebtsBannerProps) => {
	const t = useTranslations("pages.RefinancePage");
	const { format } = useCurrency();

	return (
		<Alert severity="info" size="sm">
			{hasSuggestions
				? t("requiredDebts.bannerSuggested", { amount: format(mandatory) })
				: t("requiredDebts.banner", { amount: format(mandatory) })}
		</Alert>
	);
};
